// Source of Thruth for document overview.
// This is the initial state.
export default {
    docid: 0,
    doctype: '',
    docnumber: '',
    doclabel: '',
    docFile: null,
    step: '',
    statistics: [],

    rateCategoryId: 0,
    thirdid: 0,
    layoutId: 0,
    langId: 0,
    deadlines: [],
    rows: [],
    docNumberFormat: {},
    unitNumberFormat: {},

    // Permissions
    canEditDocument: false,
    canBaseEditDocument: false,

    // Plugins
    hasExpensePlugin: false,
    hasTimeTrackingPlugin: false,

    // Dunnings
    dunningState: 'disabled',
    sentDunnings: [],
    sentDunningsNumber: 0,
    plannedDunnings: [],
    plannedErrors: [],

    // Sale accounting codes from corp
    accountingCodes: [],

    // Temporaire var, need to rewrite 'resume' tab in vue.js
    seletedRow: 0,

    // Margin tab
    creditnotesLoaded: false,
    creditnotes: [],
    purchasesLoaded: false,
    purchases: [],
    expensesLoaded: false,
    expenses: [],
    rowsLoaded: false,
    customsLoaded: false,
    customs: [],
    timetrackingsLoaded: false,
    timetrackings: [],

    fileId: '',

    hasAlreadyFetchedDocFile: false,
};
